import React, { useState } from 'react';
import { Grid, Card, Typography, CardContent, Modal, Box, Button } from '@mui/material';
import './_Projects.scss';

const projects = [
    {
        id: 1,
        name: 'Wolf Chain',
        description: 'Wolf Chain is a blockchain-powered platform integrated with AI to offer unparalleled security, transparency, and efficiency in transactions and data management. By combining blockchain and AI, it enhances smart contracts, data integrity, and transaction processing.',
        techStack: 'Backend: Ethereum (Solidity), Python (AI/ML) | Frontend: React, Material UI'
    },
    {
        id: 2,
        name: 'CyberSecPro',
        description: 'CyberSecPro is an AI-driven cybersecurity education platform that creates personalized learning paths and interactive challenges based on the user\'s experience and current cybersecurity threats.',
        techStack: 'Backend: Python (AI/ML), Flask/Django | Frontend: React, Material UI | Database: PostgreSQL'
    },
    {
        id: 3,
        name: 'CodeMetrics',
        description: 'An AI-powered code quality and engineering analytics platform that helps developers and teams identify technical debt, improve maintainability, track performance, and make data-driven development decisions.',
        techStack: 'Backend: Python (AI/ML), Node.js | Frontend: React, Material UI | Database: PostgreSQL'
    },
    {
        id: 4,
        name: 'Vant',
        description: 'A modern service marketplace connecting customers with trusted local professionals. Vant simplifies discovering, booking, and managing services through an intuitive, mobile-first experience.',
        techStack: 'Backend: Node.js (NestJS), PostgreSQL | Frontend: React Native, Material UI | Database: PostgreSQL'
    },
    {
        id: 5,
        name: 'RelayR',
        description: 'A real-time communication platform designed for teams, communities, and organizations. RelayR provides secure messaging, channels, collaboration tools, and seamless communication across devices.',
        techStack: 'Backend: Node.js, WebSockets | Frontend: React, Material UI | Database: MongoDB'
    },
    {
        id: 6,
        name: 'Moments',
        description: 'A social platform focused on sharing experiences, memories, and everyday moments. Built to encourage authentic connections through photos, stories, and community engagement.',
        techStack: 'Backend: Node.js (NestJS), PostgreSQL | Frontend: React Native, Material UI | Database: PostgreSQL'
    },
    {
        id: 7,
        name: 'AGL',
        description: 'A competitive gaming platform that empowers amateur players and teams to compete in ladders, leagues, tournaments, and seasonal competitions while building their esports presence.',
        techStack: 'Backend: Node.js (NestJS), PostgreSQL | Frontend: React, Material UI | Database: PostgreSQL'
    },
    {
        id: 8,
        name: 'Authentiq',
        description: 'Advanced facial authenticity technology designed to help identify manipulated, filtered, AI-generated, or misleading profile images. Authentiq promotes transparency and trust across social, dating, and online platforms.',
        techStack: 'Backend: Python (AI/ML), Flask | Frontend: React, Material UI | Database: PostgreSQL'
    },
];

const Projects = () => {
    const [open, setOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    const handleOpen = (project) => {
        setSelectedProject(project);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedProject(null);
    };

    return (
        <section className="projects-section" id="projects">
            <Typography variant="h5" className="subtitle">
                Projects Currently in Development
            </Typography>
            <Grid container spacing={3}>
                {projects.map((project) => (
                    <Grid item xs={12} sm={6} md={3} key={project.id}>
                        <Card className="project-item" onClick={() => handleOpen(project)}>
                            <CardContent className="project-content">
                                <Typography variant="h6" className="project-name">
                                    {project.name}
                                </Typography>
                                <Typography variant="body2" className="project-description">
                                    {project.description.substring(0, 100)}...
                                </Typography>
                                <span className="learn-more">Learn more &rarr;</span>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Modal open={open} onClose={handleClose}>
                <Box className="modal-box">
                    {selectedProject && (
                        <>
                            <Typography variant="h5" className="modal-title">
                                {selectedProject.name}
                            </Typography>
                            <Typography variant="body1" sx={{ mt: 2, color: '#ccc', lineHeight: 1.7 }}>
                                {selectedProject.description}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 3, color: '#999' }}>
                                <strong style={{ color: '#fff' }}>Tech Stack:</strong>{' '}
                                {selectedProject.techStack}
                            </Typography>
                            <Button
                                onClick={handleClose}
                                variant="outlined"
                                sx={{
                                    mt: 4,
                                    borderColor: 'rgba(255,255,255,0.2)',
                                    color: '#fff',
                                    '&:hover': { borderColor: '#EF002F', color: '#EF002F' },
                                }}
                            >
                                Close
                            </Button>
                        </>
                    )}
                </Box>
            </Modal>
        </section>
    );
};

export default Projects;
